import { Injectable } from '@angular/core';

// Service
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';

@Injectable({
  providedIn: 'root'
})
export class DealerService {
  public selectedAccountNo: any;
  public selectedProductForModificaionOrderNumber: any;
  public selectedProductForModificaionAccountNumber: any;

  public isNaveForModify: boolean;
  public selectedProductForModificaion: any;
  public selectedDealerOrderId: number;
  constructor(private configService: ConfigService,
    private networkService: NetworkService) {
  }

  // Get Dealer order list
  public getDealerOrdersList(cropYear, shipToAccount) {
    return this.networkService.getRequest(this.configService.getDealerOrdersListUrl() + '?cropYear=' + cropYear + '&shipToAccount=' + shipToAccount);
  }

  // Get Dealer order detail
  public getDealerOrderItems(cropYear, shipToAccount, dealerOrderId) {
    return this.networkService.getRequest(this.configService.getDealerOrderItemsUrl() + '?cropYear=' + cropYear + '&shipToAccount=' + shipToAccount + '&dealerOrderId=' + dealerOrderId);
  }

  // Get Dealer detail
  public getDealerDetail(accountNumber, cropYear) {
    return this.networkService.getRequest(this.configService.getDealerDetailUrl() + '?accountNumber=' + accountNumber + '&cropYear=' + cropYear);
  }

  // Get Dealer order detail
  public getDealerOrderDetail(dealerOrderId) {
    return this.networkService.getRequest(this.configService.getDealerOrderDetailUrl() + '?dealerOrderId=' + dealerOrderId);
  }

  // Get item growers detail
  public getDealerGrowerDetail(cropYear, itemId, shipToAccount) {
    return this.networkService.getRequest(this.configService.getDealerGrowerDetailUrl() + '?cropYear=' + cropYear + '&itemId=' + itemId + '&shipToAccount=' + shipToAccount);
  }

  // Add Dealer order
  public dealerOrderAdd(data: any) {
    return this.networkService.postRequest(this.configService.getDealerOrderAddUrl(), data);
  }

  // Update Dealer order
  public dealerOrderUpdate(data: any) {
    return this.networkService.postRequest(this.configService.getDealerOrderUpdateUrl(), data);
  }

  // Get Modify item details
  public getModifyItem(itemId, shipToAccount, cropYear, changeType, quantity) {
    return this.networkService.getRequest(this.configService.getModifyItemUrl() + '?itemId=' + itemId + '&shipToAccount=' + shipToAccount + '&cropYear=' + cropYear + '&changeType=' + changeType + '&quantity=' + quantity);
  }

  // Get dealer account list
  public getDealerAccountList(cropYear, shipToAccount) {
    return this.networkService.getRequest(this.configService.getDealerAccountListUrl() + '?cropYear=' + cropYear + '&shipToAccount=' + shipToAccount);
  }

  // Get EA Status for dealer Order
  public getDealerEaStatus(code) {
    return this.networkService.getRequest(this.configService.getDealerEaStatusUrl() + '?code=' + code);
  }

  // check is the current user is allowed to do internal transfer
  public checkUser4InternalTransfer() {
    return this.networkService.getRequest(this.configService.getcheckUser4InternalTransferUrl());
  }

  // Get To Account detail data via filter
  public getToccountList(businessName, city, state, accountNo) {
    return this.networkService.getRequest(this.configService.getDelearAccountListUrl() + '?businessName=' + businessName + '&city=' + city + '&state=' + state + '&accountNo=' + accountNo);
  }

  public validateEaModifiableUnitsItem(data: any) {
    return this.networkService.postRequest(this.configService.getValidateEaModifiableItemsUrl(), data);
  }

  public getEaMinimumUnitException(data: any) {
    return this.networkService.postRequest(this.configService.getEaMinimumUnitExceptionUrl(), data);
  }

  public UpdateEaUnitsItems(data: any) {
    return this.networkService.postRequest(this.configService.UpdateEaUnitsItemsUrl(), data);
  }
  // to delete from account from the to account result
  setSelectedAccountNo(selectedAccountNo) {
    this.selectedAccountNo = selectedAccountNo;
  }

  getSelectedAccountNo() {
    return this.selectedAccountNo;
  }

  // Get To Items details for ea swap
  public getDealerOrderToItems(data: any) {
    return this.networkService.postRequest(this.configService.getDealerOrderToItemUrl(), data);
  }

  // Get To Items details for ea swap
  public eaSwapUpdateOrder(data: any) {
    return this.networkService.postRequest(this.configService.eaSwapUpdateOrderUrl(), data);
  }

  // Get EA Modifiable Units
  getFromEaModifiableUnits(data: any) {
    return this.networkService.postRequest(this.configService.getFromEaModifiableUnitsUrl(), data);
  }

  // Get EA Items
  public getDealerOrderEaItems(data: any) {
    return this.networkService.postRequest(this.configService.getDealerOrderEaItemsUrl(), data);
  }

  // Update EA Add Product to order
  public eaAddUpdateOrder(data: any) {
    return this.networkService.postRequest(this.configService.eaAddUpdateOrderUrl(), data);
  }

  // Calculate ea units for modify item
  public calculateEAUnitsModifyItem(data: any) {
    return this.networkService.postRequest(this.configService.calculateEAUnitsModifyItemUrl(), data);
  }
}
